import { editPortfolio as EditPortfolio } from './routines';
import type { EditPortfolioPayload } from './interface';

export function editPortfolio(data: EditPortfolioPayload) {
  return EditPortfolio.trigger(data);
}
